import { combineReducers } from 'redux';
import { interactiveHeaderReducer } from './interactive-header';

export const navigationReducer = combineReducers({
    interactiveHeader: interactiveHeaderReducer,
});
